import { addDays, DateOnly } from '@if/core/date'
import { t } from '@if/core/i18n'
import * as yup from '@if/core/yup'

export const MIN_LOAN_AMOUNT = 500

export const customBuydownSchema = () =>
  yup.object({
    contribution: yup.number().required().min(0.005).max(0.2),
    activeFrom: yup.dateOnly().required().min(addDays(DateOnly.today(), 1)),
    expiresOn: yup.dateOnly().defined().nullable().min(yup.ref('activeFrom'), { offsetDays: 1 }),

    maxFinancingAmount: yup
      .number()
      .min(MIN_LOAN_AMOUNT, () => t('customBuydown.errors.maxFinancingAmountMin', { min: MIN_LOAN_AMOUNT }))
      .defined()
      .nullable(),

    ownedByBanner: yup.boolean().required().default(false),
  })

export type CustomBuydownFormValues = yup.InferType<ReturnType<typeof customBuydownSchema>>
